var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"table",attrs:{"params":_vm.tableColumn,"table-data":_vm.tableData,"table-loading":_vm.tableLoading,"need-index":false},scopedSlots:_vm._u([{key:"clueStatus",fn:function(ref){
var row = ref.row;
return [_c('ColorText',{attrs:{"color-key":row.clueStatus,"color-map":_vm.statusColorMap,"value":_vm.clueStatus[row.clueStatus]}})]}},{key:"startAt",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm._f("filterDateFn")(row.startAt))+"-"+_vm._s(_vm._f("filterDateFn")(row.endAt)))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }